export const defaultState = {
	name: '',
	user: null,
	account: '',
	location: '',
	locations_count: 0,
	sessions_count: 0,
	session_items_count: 0,
	ffl_boss_linked: false,
	fflboss_pos_combo: false,
	has_range_manager: false,
	auto_cc_fee: false,
	apply_cc_fee_to_debit: true,
	ffl_force_taxable: false,
	skip_print_preview: false,
	show_customer_info: false,
	show_tax_breakdown: false,
};
